<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-row>
        <el-form :inline="true" ref="searchForm" :model="formInline" class="demo-form-inline">
          <el-form-item label="业务系统"   prop="sysId">
            <el-select
              v-model="formInline.sysId"
              placeholder="请选择业务系统"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in sysData"
                :key="index"
                :label="item.systemName"
                :value="item.systemId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送渠道"   prop="sysId">
            <el-select
              v-model="formInline.sendChannel"
              placeholder="请选择发送渠道"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in channelData"
                :key="index"
                :label="item.channelName"
                :value="item.channelCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送状态">
            <el-select v-model="formInline.state" clearable filterable placeholder="请选择发送状态">
              <el-option
                label="成功"
                value="1">
              </el-option>
              <el-option
                label="待确认"
                value="0">
              </el-option>
              <el-option
                label="失败"
                value="2">
              </el-option>
              <el-option
                label="取消"
                value="3">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="float-r">
            <el-button size="small" @click="onReset('searchForm')">重置</el-button>
            <el-button size="small" type="primary" @click="queryAll" >查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-card>
    <el-card >
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
        <!-- <el-button type="primary" size="small" style="float: right; margin-top: -10px; margin-right: 10px;" @click="handleAdd" icon="el-icon-plus"></el-button> -->
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="业务系统"
          :show-overflow-tooltip="tooltip"
          width="120">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发送渠道"
          :show-overflow-tooltip="tooltip"
          width="100">
          <template slot-scope="scope">
            <span >{{ scope.row.msgName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发送内容"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.msgContent }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发送对象"
          :show-overflow-tooltip="tooltip"
          width="240">
          <template slot-scope="scope">
            <span >{{ scope.row.receiveAddr}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发送状态"
          width="80">
          <template slot-scope="scope">
            <span >{{ scope.row.sendStatus === '0' ? '待确认': scope.row.sendStatus === '1' ? '成功' : scope.row.sendStatus === '2' ? '失败' : '取消' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发送时间"
          width="180">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
</style>
<script>
export default {
  name: 'informationHistory',
  data () {
    return {
      formInline: {
        sendChannel: '',
        sysId: '',
        state: ''
      },
      channelData: [],
      tooltip: true,
      tableData: [],
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.formInline.sendChannel = ''
      this.formInline.state = ''
      this.formInline.sysId = ''
    },
    initData () {
      this.query()
    },
    queryAll () {
      this.currentPage = 1
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.channelCode = this.formInline.sendChannel
      op.sendStatus = this.formInline.state
      op.sysIds = sysIds
      this.$axios({
        url: _this.$API.config.queryMsgHistoryByPageResp,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    let op = {}
    let _this = this
    op.pageNum = 1
    op.pageSize = 100
    this.$axios({
      url: _this.$API.config.queryChannelByPageResp,
      // url: 'http://172.16.9.104:5010/agw/msg/queryChannelByPageResp',
      method: 'post',
      data: op
    }).then((response) => {
      console.log(response)
      _this.channelData = response.data.resData.resultList
    }).catch((err) => {
      console.log(err)
    })
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/notificationCenter/informationHistory.vue